import React from 'react';
import { useSelector } from 'react-redux';
import { getFilter } from '../../../../../../stores/algos-list/getters';
import { makeStyles } from '@material-ui/core';

const useStyles = makeStyles(() => ({
  root: {
    display: 'inline-flex',
    borderRadius: '20%',
    overflow: 'hidden',
    justifyContent: 'center',
    alignItems: 'center',
    fontWeight: 600,
    padding: '4px 8px',
    backgroundColor: 'var(--color-colorPrimary-main)',
    color: '#fff',
    fontSize: '0.75rem',
    border: 0,
    cursor: 'pointer',
  },
}));

export function useActiveValueCount() {
  const views = useSelector((state) => {
    const { views = {} } = getFilter(state);
    return views;
  });

  return Object.keys(views ?? {}).length;
}

const Count = ({ onClick }) => {
  const classes = useStyles();
  const count = useActiveValueCount();

  return (
    <button className={classes.root} onClick={onClick}>
      {count}
    </button>
  );
};

export default Count;
